<template>
    <page-table/>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-awsStore',
  components: {
    PageTable,
  },
}
</script>